import React from "react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import SettingsHeader from "./SettingsHeader";
import ProfileEdit from "./ProfileEditCard";
import HorizontalLine, {
  HorizontalLineFull,
} from "../../assets/utils/HorizontalLine";
import GradeCard from "./GradeCard";
import Switch from "../../assets/utils/Switch";
import { DetailsButton } from "../../assets/buttons/CustomButton";
import OptionRow from "../../assets/utils/OptionRow";
import DeleteAccountModal from "./DeleteAccountModal";
import LogoutModal from "./LogoutModal";
import TermsServices from "./TermsServices";
import { toggleMute } from "../../store/slice/muteSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const SettingsDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isMuted } = useSelector((state) => state.mute);

  return (
    <div
      className="min-h-screen flex flex-col   bg-blue-50 font-mali "
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <SettingsHeader />
      <div className="w-[60%] mr-auto ml-auto mt-20 mb-20">
        <ProfileEdit />
        <HorizontalLine name="Course" />
        <GradeCard />
        <HorizontalLine name="Settings" />
        <Switch
          name="Sound"
          defaultValue={!isMuted}
          onToggal={() => dispatch(toggleMute())}
        />
        <HorizontalLineFull />

        <div className="flex justify-around">
          <DetailsButton name="FAQ" goTo="faq" />
          <DetailsButton name="About us" goTo="settings/about" />
        </div>
        <HorizontalLine name="My Account" />
        <OptionRow
          isButton="true"
          name="Billing Details"
          buttonName="View"
          onClickHandler={() => {
            navigate("/billing-details");
          }}
        />
        <LogoutModal />
        <DeleteAccountModal />
        <HorizontalLineFull />
        <OptionRow
          isButton="true"
          name="Have any questions or suggestions for us?"
          buttonName="Contact us"
          goTo="contact"
          onClickHandler={() => {navigate(`/contact`)}}
        />
        <TermsServices />
      </div>
    </div>
  );
};

export default SettingsDashboard;
